import { getPreviousSearchResults } from './get-previous-results';

export const MAXIMUM_PREVIOUS_SEARCH_RESULTS = 5;

export function updatePreviousSearchResults(newQuery: string) {
  const previousResults = getPreviousSearchResults();
  const indexOfNewQueryInResults = previousResults.indexOf(newQuery);
  const queryExists = indexOfNewQueryInResults !== -1;

  if (queryExists) {
    previousResults.splice(indexOfNewQueryInResults, 1);
  } else if (previousResults.length >= MAXIMUM_PREVIOUS_SEARCH_RESULTS) {
    previousResults.pop();
  }

  previousResults.unshift(newQuery);

  localStorage.setItem('previousSearchResults', JSON.stringify(previousResults));

  return previousResults;
}
